'use client';

import { ArrowRight } from 'lucide-react';
import { useTranslations } from 'next-intl';
import styles from '@/components/audit/ProReportResults.module.css';
import { Button } from '@/components/ui/Button';

interface ReportCTAProps {
  onBookCall: () => void;
  locale?: string;
  issueCount?: number;
}

const CONTACT_EMAIL = 'hello@interfaceaudit.com';

/**
 * Report closer. The same copy and the same two offers the PDF closer prints
 * (`report.closer` in the messages): the report reveals and sizes the problem;
 * the Expert Review is the next step and the retainer is where the work ships.
 */
export function ReportCTA({ onBookCall }: ReportCTAProps) {
  const t = useTranslations('report.closer');
  const offers = [
    { name: t('expertName'), price: t('expertPrice'), summary: t('expertSummary') },
    { name: t('retainerName'), price: t('retainerPrice'), summary: t('retainerSummary') },
  ];

  return (
    <section className={styles.ctaSection}>
      <div className={styles.ctaContent}>
        <h2 className={styles.ctaTitle}>{t('title')}</h2>
        <p className={styles.ctaDescription}>{t('intro')}</p>
        <div className={styles.ctaOffers}>
          {offers.map((offer) => (
            <div key={offer.name} className={styles.ctaOffer}>
              <div className={styles.ctaOfferHead}>
                <h3 className={styles.ctaOfferName}>{offer.name}</h3>
                <span className={styles.ctaOfferPrice}>{offer.price}</span>
              </div>
              <p className={styles.ctaOfferSummary}>{offer.summary}</p>
            </div>
          ))}
        </div>
        <div className={styles.ctaButtons}>
          <Button onClick={onBookCall} className={styles.ctaPrimary}>
            {t('cta')}
            <ArrowRight size={18} />
          </Button>
        </div>
        <p className={styles.ctaContact}>
          <a href={`mailto:${CONTACT_EMAIL}`}>{t('contact', { email: CONTACT_EMAIL })}</a>
        </p>
      </div>
    </section>
  );
}
